var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 1.833h.537c.243 0 .476.097.648.269l3.13 3.13a.917.917 0 0 1 .268.648v13.37c0 .506-.41.917-.916.917H4.583a.917.917 0 0 1-.916-.917V2.75c0-.506.41-.917.916-.917h9.167Zm-1.833 1.834v2.75c0 1.012.82 1.833 1.833 1.833h2.75v10.083h-11V3.667h6.417Zm4.583 2.75h-2.75v-2.75h.157L16.5 6.259v.158Zm-8.25 8.25a.917.917 0 0 0 0 1.833h5.5a.917.917 0 0 0 0-1.833h-5.5Zm-.917-1.834c0-.506.41-.916.917-.916h5.5a.917.917 0 0 1 0 1.833h-5.5a.917.917 0 0 1-.917-.917Zm.917-3.666a.917.917 0 1 0 0 1.833h5.5a.917.917 0 0 0 0-1.833h-5.5Z"
  })));
};

export default SvgDocument;